import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';

import { usePageDialog } from '../hooks/use-page-dialog';

interface PageDialogLinkProps<T> {
    Component: React.ComponentType<T>;
    componentProps: T;
    url: string;
}

export function PageDialogLink<T>(props: PropsWithChildren<PageDialogLinkProps<T>>) {
    const { Component, componentProps, url } = props;
    const { showDialog } = usePageDialog();

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        showDialog(<Component {...componentProps} />, url);
    };

    return <span onClickCapture={handleClick}>{<Link to={url}>{props.children}</Link>}</span>;
}
